import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=96b2adba&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=96b2adba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b2adba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96b2adba')) {
      api.createRecord('96b2adba', component.options)
    } else {
      api.reload('96b2adba', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=96b2adba&scoped=true&", function () {
      api.rerender('96b2adba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FaxLTpuSJ7Ab/JS/comp/DateRange.vue"
export default component.exports